import * as React from "react";
import { useCallback, useEffect, useState } from "react";

import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import {
  TransactionStateType,
  useTransactionState,
} from "@hl/shared-features/lib/features/evm-tx/TransactionContext";

import CollectorsList from "~features/MintPage/apollo/CollectorsList";
import { useGetAudienceOfCollectionLazyQuery } from "~features/MintPage/queries.graphql.generated";
import useMintState from "~hooks/useMintState";

const CollectorsListTab = ({ collectionId }: { collectionId?: string }) => {
  const [activePage, setActivePage] = useState<number>(1);
  const { isSmall, isLarge } = useMantineMediaQueries({
    withInitialValues: true,
  });
  const collectorsPageSize = isLarge ? 30 : isSmall ? 20 : 10;
  const { txnId } = useMintState();
  const transactionState = useTransactionState(txnId);

  const [
    audienceOfCollectionQuery,
    { data: audienceData, loading, fetchMore, refetch },
  ] = useGetAudienceOfCollectionLazyQuery({
    variables: {
      collectionId: collectionId!,
      cursor: 0,
      limit: collectorsPageSize,
      findEnsNames: true,
    },
  });

  useEffect(() => {
    if (
      transactionState &&
      transactionState.type === TransactionStateType.Done
    ) {
      refetch();
    }
  }, [transactionState, refetch]);

  const loadMore = useCallback(() => {
    setActivePage(activePage + 1);
    fetchMore({
      variables: {
        cursor: activePage,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        fetchMoreResult.getAudienceOfCollection.members = [
          ...(previousResult?.getAudienceOfCollection?.members ?? []),
          ...(fetchMoreResult?.getAudienceOfCollection?.members ?? []),
        ];
        return fetchMoreResult;
      },
    });
  }, [fetchMore, activePage]);

  useEffect(() => {
    if (collectionId) {
      audienceOfCollectionQuery();
    }
  }, []);

  return (
    <CollectorsList
      collectors={audienceData}
      compact={false}
      loadMore={loadMore}
      loading={loading}
    />
  );
};

export default CollectorsListTab;
